import { render, staticRenderFns } from "./Roleteiro.vue?vue&type=template&id=00f841ce&scoped=true&"
import script from "./Roleteiro.vue?vue&type=script&lang=js&"
export * from "./Roleteiro.vue?vue&type=script&lang=js&"
import style0 from "./Roleteiro.vue?vue&type=style&index=0&id=00f841ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f841ce",
  null
  
)

export default component.exports